module.exports = __webpack_public_path__ + "img/m10.1798c6e3.jpg";